import { Component, EventEmitter, Injectable, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
declare var require: any
const Swal = require('sweetalert2');

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  @ViewChild('confirmationModal') private modalContent!: TemplateRef<ConfirmationModalComponent>
  @Output() newConfirmationEvent = new EventEmitter<string>();
  @Input() modalStyle: any;
  @Input() modalTitle: any;
  @Input() modalBody: any;
  @Input() modalButtonColor: any;
  private modalRef!: NgbModalRef;

  constructor(config: NgbModalConfig, private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
  }


  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalRef = this.modalService.open(this.modalContent, { centered: true })
      this.modalRef.result.then((result) => {
        console.log(result);
        this.newConfirmationEvent.emit(result);
      }, (reason) => {
        console.log(reason);
      });
    })
  }


  basicAlert() {
    Swal.fire({
      title: this.modalTitle,
      confirmButtonColor: '#6259ca'
    })
  }
  titleAlert() {
    Swal.fire({
      title: this.modalTitle,
      text: 'All are available in the template',
      confirmButtonColor: '#6259ca'
    })
  }
  successAlert(title: any, body: any) {
    Swal.fire({
      icon: 'success',
      title: title,
      text: body,
      confirmButtonColor: '#6259ca'
    })
  }

  loaderInstance: any;
  LoaderAlert() {
    const spinnerHtml = `
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div> `;

    this.loaderInstance = Swal.fire({
      title: spinnerHtml,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: false,
    })
  }

  dismissLoader() {
    this.loaderInstance?.close();
  }

  errorAlert(title: any, body: any) {
    Swal.fire({
      icon: 'error',
      title: title,
      text: body,
      confirmButtonColor: '#6259ca'
    })
  }

  confirmationAlert(title: any, body: any, confirmButtonText?: any, cancelButtonText?: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      Swal.fire({
        icon: 'warning',
        title: title,
        text: body,
        showCancelButton: true,
        confirmButtonColor: '#6259ca',
        cancelButtonColor: '#6259ca',
        confirmButtonText: confirmButtonText ? confirmButtonText : 'Confirm',
        cancelButtonText: cancelButtonText ? cancelButtonText : 'Dismiss',
        reverseButtons: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          resolve(true)
        }
        else {
          resolve(false)
        }
      })
    });
  }

  async parameterAlert(title: any, text: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      Swal.fire({
        icon: "warning",
        title: title,
        text: text,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        confirmButtonColor: '#6259ca',
        cancelButtonText: 'Dismiss',
        cancelButtonColor: '#6259ca',
        reverseButtons: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            icon: 'success',
            confirmButtonColor: '#6259ca'
          }).then(() => resolve(true));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            title: 'Cancelled!',
            text: 'Your imaginary file is safe :)',
            icon: 'error',
            confirmButtonColor: '#6259ca'
          }).then(() => resolve(false));
        } else {
          // Handle other dismiss scenarios if needed
          resolve(false);
        }
      });
    });
  }

  imageAlert() {
    Swal.fire({
      title: 'Lovely',
      text: 'Your image is uploaded.',
      imageUrl: '../../assets/img/brand/logo.png',
      confirmButtonColor: '#6259ca'
    })
  }

  timerAlert() {
    Swal.fire({
      title: 'Auto close alert!',
      text: 'I will close in 2 seconds.',
      confirmButtonColor: '#6259ca',
      timer: 2000,
      timerProgressBar: true,
    })
  }

  animationAlert() {
    Swal.fire({
      title: 'Custom animation with Animate.css',
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      },
      confirmButtonColor: '#6259ca',
    })
  }



}
